import { __extends, __assign } from 'tslib';
import * as React from 'react';
import { UitkPagingButton } from './uitk-paging-button.esm.js';

var UitkPagingPrevButton = /** @class */ (function (_super) {
    __extends(UitkPagingPrevButton, _super);
    function UitkPagingPrevButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UitkPagingPrevButton.prototype.render = function () {
        return React.createElement(UitkPagingButton, __assign({}, this.props, { icon: "chevron_left" }));
    };
    UitkPagingPrevButton.displayName = 'UitkPagingPrevButton';
    return UitkPagingPrevButton;
}(React.Component));

export { UitkPagingPrevButton };
